// Signál detailu produktu, který nese VÝHRADNĚ dataLayer — v DOM Shoptetu pro
// něj kotva neexistuje. Funkcionalita z vrstvy předchůdce, kterou redesign
// nenahrazuje (issue #47, audit `docs/go-live/2026-08-27-audit-html-kodu-a-doplnku.md`
// §2 bod 1): „Poslední kusy skladem" při 0 < qty < 5 (`shoptet.product.codes[]`).
//
// Poznámka o velkoobchodní slevě z `priceRatio` (§2 bod 2) zanikla 2026-09-13:
// velkoobchod Jiposu jede přes ceníky 13/16/19 s `priceRatio` 1, takže se nikdy
// nevykreslila. Nahradila ji VO cena proti běžné (`wholesalePrice.js`).
//
// Modul je ČISTÝ: bere data, vrací hodnoty. Nesahá na DOM ani na dataLayer —
// kdo ho volá a kam kreslí, řeší `productDetail.js`. Díky tomu jde otestovat
// unit testem bez prohlížeče (`tools/devcheck/product-detail.mjs`).

// Nad tímhle počtem kusů se vlaječka nekreslí (hranice z modulu předchůdce).
export const LAST_PIECES_MAX = 5;

/**
 * Množství z dataLayeru na číslo.
 *
 * PAST: Shoptet vrací množství jako STRING a nad prahem „hlídání skladu" ho
 * schválně rozostří — „> 5" nebo „5+". Takovou hodnotu nesmíme číst jako 5
 * (`parseInt('> 5')` je NaN, ale `parseInt('5+')` je 5 a vlaječka by lhala
 * u produktu, kterého je na skladě spousta). Cokoli, co není holé číslo,
 * proto znamená NEZNÁMO (`null`), ne nulu ani pět.
 */
export function parseQuantity(raw) {
  if (raw == null) return null;
  const s = String(raw).trim().replace(/\s/g, '');
  if (!/^-?\d+(?:[.,]\d+)?$/.test(s)) return null;
  const n = parseFloat(s.replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}

/**
 * Množství jedné skladové karty (`codes[i]`). Vlastní `quantity` má přednost;
 * když je rozostřené („> 5"), zkusí se ještě součet vnořených `stocks[]`
 * (vícesklad — modul předchůdce je uměl číst taky). Neznámo kdekoli = null.
 */
export function codeQuantity(code) {
  if (!code) return null;
  const own = parseQuantity(code.quantity);
  if (own != null) return own;
  const stocks = Array.isArray(code.stocks) ? code.stocks : null;
  if (!stocks || !stocks.length) return null;
  let sum = 0;
  for (const stock of stocks) {
    const q = parseQuantity(stock && stock.quantity);
    if (q == null) return null;
    sum += q;
  }
  return sum;
}

/**
 * Kolik kusů produktu (přes všechny varianty) zbývá, když je to méně než
 * `LAST_PIECES_MAX`. Jinak `null` = vlaječka se nekreslí.
 * Neznámé množství u KTERÉKOLI varianty = null: raději nic než falešná tíseň.
 */
export function lastPiecesLeft(product) {
  const codes = product && Array.isArray(product.codes) ? product.codes : null;
  if (!codes || !codes.length) return null;
  let total = 0;
  for (const code of codes) {
    const q = codeQuantity(code);
    if (q == null) return null;
    total += q;
  }
  if (!(total > 0) || total >= LAST_PIECES_MAX) return null;
  return total;
}
